export const messages = {
  email: "Please, enter valid email",
  required: "This field is required",
  digits: "Accepted only digits",
  "one-digit": "Accepted only one digit",
  minLength: "Incorrect phone number",
  maxLength: "Incorrect phone number",
  phone: "Incorrect phone number",
};
